import Vue from 'vue'
import VueRouter from 'vue-router'
import LogIn from '../views/LogIn.vue'
import ChangeNumber from '../views/ChangeMobileNumber.vue'
import Iframetemple from '../views/iframe.vue'
// import HomeOne from '../views/HomeOne.vue'
import HomeTwo from '../views/HomeTwo.vue'
import HomeThree from '../views/HomeThree.vue'
import HomeFour from '../views/HomeFour.vue'
import HomeFive from '../views/HomeFive.vue'
import HomeSix from '../views/HomeSix.vue'
import HomeSeven from '../views/HomeSeven.vue'
import HomeEight from '../views/HomeEight.vue'
import News from '../views/News.vue'
import SingleNews from '../views/SingleNews.vue'
import Contact from '../views/Contact.vue'
import ServiceDetails from '../views/ServiceDetails'
import Error from '../views/Error.vue'
import AboutUs from '../views/About.vue'
import HomePage from '../views/HomePage.vue'
import ViewPost from '../views/ViewPost.vue'
import CompanyRegister from '../views/CompanyRegister.vue'
import PaymentHistory from '../views/PaymentHistory.vue'
import WaitingPost from '../views/WaitingPost.vue'
import PostView from '../views/PostView.vue'
import Forum from '../views/Forum.vue'
import CandidateProfile from '../views/CandidateProfile.vue'
import ViewedEmployerList from '../views/ViewedEmployerList.vue'
import EmployeeView from '../views/EmployeeView.vue'
import NearByCompany from '../views/NearCompany.vue'
import Kycregister from "@/components/CompanyRegister/kyc.vue";


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'LogIn',
        component: LogIn
    },
    {
        path: '/change-mobile-number',
        name: 'ChangeNumber',
        component: ChangeNumber
    },
    {
        path: '/plan-purchase',
        name: 'iframetemple',
        component: Iframetemple
    },
    {
        path: '/home-page',
        name: 'HomePage',
        component: HomePage
    },
    {
        path: '/view-post',
        name: 'ViewPost',
        component: ViewPost
    },
    {
        path: '/post-view',
        name: 'PostView',
        component: PostView
    },
    {
        path: '/waiting-post',
        name: 'WaitingPost',
        component: WaitingPost
    },
    {
        path: '/forum',
        name: 'Forum',
        component: Forum
    },
    {
        path: '/candidate-profile',
        name: 'CandidateProfile',
        component: CandidateProfile
    },
    {
        path: '/viewed-employer-list',
        name: 'ViewedEmployerList',
        component: ViewedEmployerList
    },
    {
        path: '/employee-view',
        name: 'EmployeeView',
        component: EmployeeView
    },
    {
        path: '/company-register',
        name: 'CompanyRegister',
        component: CompanyRegister
    },
    {
        path: '/kyc-register',
        name: 'Kycregister',
        component: Kycregister
    },
    {
        path: '/payment-history',
        name: 'PaymentHistory',
        component: PaymentHistory
    },
    {
        path: '/near-by-company',
        name: 'NearByCompany',
        component: NearByCompany
    },
    {
        path: '/home-two',
        name: 'HomeTwo',
        component: HomeTwo
    },
    {
        path: '/home-three',
        name: 'HomeThree',
        component: HomeThree
    },
    {
        path: '/home-four',
        name: 'HomeFour',
        component: HomeFour
    },
    {
        path: '/home-five',
        name: 'HomeFive',
        component: HomeFive
    },
    {
        path: '/home-six',
        name: 'HomeSix',
        component: HomeSix
    },
    {
        path: '/home-seven',
        name: 'HomeSeven',
        component: HomeSeven
    },
    {
        path: '/home-eight',
        name: 'HomeEight',
        component: HomeEight
    },
    {
        path: '/service-details',
        name: 'ServiceDetails',
        component: ServiceDetails
    },
    {
        path: '/about-us',
        name: 'AboutUs',
        component: AboutUs
    },
    {
        path: '/news',
        name: 'News',
        component: News
    },
    {
        path: '/single-news',
        name: 'SingleNews',
        component: SingleNews
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/error',
        name: 'Error',
        component: Error
    }
    // {
    //   path: '/about',
    //   name: 'About',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    // stop stop cache
    // scrollBehavior() {
    //     document.getElementById('app').scrollIntoView();
    // }
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            document.getElementById('app').scrollIntoView();
        }
    }
})

router.beforeEach((to, from, next) => {
    // // Incorrect condition causing unintended redirect
    // if (someCondition) {
    //     next('/'); // This could cause unintended navigation to the root
    // } else {
    //     next(); // Always allow navigation if not redirecting
    // }

    // console.log('from', from);
    // console.log('to', to,);
    // console.log('next', next);
    next();
});
export default router
